import React, { Component } from "react";
import classSet from "react-classset";
import Modal from "../Modal/Modal";
import AudioPlayer from "../AudioPlayer/AudioPlayer";
import LearnMore from "../LearnMore/LearnMore";
import GridItem from "../GridItem/GridItem.js";
import AppBackground from "../AppBackground/AppBackground";
import { getComponentContent } from "../../helpers.js";
import ShareButton from "../ShareButton/ShareButton";
const closeIcon = process.env.REACT_APP_IMAGES_ROOT + "SSC-back.png";
const soundSleepIcon = process.env.REACT_APP_IMAGES_ROOT + "DIY-massage.svg";
const restfulTipsIcon = process.env.REACT_APP_IMAGES_ROOT + "restful-tips.svg";
const skinSleepIcon = process.env.REACT_APP_IMAGES_ROOT + "skin-sleep.svg";
const shopIcon = process.env.REACT_APP_IMAGES_ROOT + "shop-ssc.svg";
const binauralIcon = process.env.REACT_APP_IMAGES_ROOT + "sound-sleep.svg";
const scentsIcon =
  process.env.REACT_APP_IMAGES_ROOT + "essential-oil-science.svg";
const diyVideo = process.env.REACT_APP_VIDEOS_ROOT + "diy.mp4";
const diyPoster = process.env.REACT_APP_IMAGES_ROOT + "diy-poster.jpg";
const captions = process.env.REACT_APP_AUDIO_ROOT + "captions.vtt";

class PlayerPage extends Component {
  constructor() {
    super();
    this.state = {
      mounted: false,
      learnMore: null
    };
    this.setLearnMore = this.setLearnMore.bind(this);
    const appEl = document.getElementsByClassName(
      "dermalogica-sound-sleep-cocoon"
    )[0];
    const customLink = appEl.dataset.productClickthrough;
    const content = getComponentContent("PlayerPage");
    const contentLink = getComponentContent("MainMenu");
    // console.log('contentLink: ', contentLink);
    this.content = {
      nucalmText: content.nucalmText,
      clickCta: content.clickCta,
      tapCta: content.tapCta,
      cookieText: content.cookie,
      leftGrid: [
        {
          title: content.grid1Title,
          icon: soundSleepIcon,
          description: content.grid2Description,
          video: diyVideo,
          videoPoster: diyPoster,
          videoCaptions: captions,
          shape: "square",
          class: "sound-sleep",
          steps: []
        },
        {
          title: content.grid2Title,
          icon: restfulTipsIcon,
          description: content.grid2Description,
          shape: "square",
          class: "restful-tips",
          steps: [
            {
              label: content.grid2Steps1Label,
              description: content.grid2Steps1Description
            },
            {
              label: content.grid2Steps2Label,
              description: content.grid2Steps2Description
            },
            {
              label: content.grid2Steps3Label,
              description: content.grid2Steps3Description
            },
            {
              label: content.grid2Steps4Label,
              description: content.grid2Steps4Description
            },
            {
              label: content.grid2Steps5Label,
              description: content.grid2Steps5Description
            },
            {
              label: content.grid2Steps6Label,
              description: content.grid2Steps6Description
            }
          ]
        },
        {
          title: content.grid3Title,
          subtitle: content.grid3Subtitle,
          icon: skinSleepIcon,
          description: content.grid3Description,
          shape: "rectangle",
          class: "nocturnal",
          steps: [
            {
              label: content.grid3Steps1Label,
              description: content.grid3Steps1Description
            },
            {
              label: content.grid3Steps2Label,
              description: content.grid3Steps2Description
            },
            {
              label: content.grid3Steps3Label,
              description: content.grid3Steps3Description
            },
            {
              label: content.grid3Steps4Label,
              description: content.grid3Steps4Description
            },
            {
              label: content.grid3Steps5Label,
              description: content.grid3Steps5Description
            }
          ]
        }
      ],
      rightGrid: [
        {
          title: content.grid4Title,
          subtitle: content.grid4Subtitle,
          icon: shopIcon,
          description: null,
          shape: "rectangle",
          class: "shop",
          steps: [],
          link:
            customLink && customLink !== "null"
              ? customLink
              : contentLink.productLink
        },
        {
          title: content.grid5Title,
          icon: binauralIcon,
          description: content.grid5Description,
          shape: "square",
          class: "binaural",
          steps: [
            {
              label: "",
              description: content.grid5Steps1Description
            },
            {
              label: "",
              description: content.grid5Steps2Description
            },
            {
              label: "",
              description: content.grid5Steps3Description
            }
          ]
        },
        {
          title: content.grid6Title,
          icon: scentsIcon,
          description: null,
          shape: "square",
          class: "scents",
          steps: [
            {
              label: "",
              description: content.grid6Steps1Description
            },
            {
              label: "",
              description: content.grid6Steps2Description
            },
            {
              label: "",
              description: content.grid6Steps3Description
            }
          ]
        }
      ]
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ mounted: true });
    }, 25);
  }

  setLearnMore(val) {
    this.setState({ learnMore: val });
  }

  render() {
    const playerPageClasses = classSet({
      ssc__page: true,
      "ssc__page--player": true,
      "ssc__page--player--showing-learn-more": this.state.learnMore
    });

    const pageWrapperClasses = classSet({
      "ssc__page-wrapper": true,
      "ssc__page-wrapper--mounted": this.state.mounted
    });

    const cta = this.props.touch ? this.content.tapCta : this.content.clickCta;
    const rightGrid = this.content.rightGrid;
    const rightGridOrdered = this.props.mqMd
      ? [rightGrid[0], rightGrid[1], rightGrid[2]]
      : [rightGrid[1], rightGrid[2], rightGrid[0]];

    if (this.props.shopUrl) {
      this.content.rightGrid[0].link = this.props.shopUrl;
    }

    return (
      <div
        className={pageWrapperClasses}
        style={{ height: this.props.appHeight }}
      >
        <AppBackground appHeight={this.props.appHeight} />

        {this.state.learnMore && (
          <Modal
            slideIn={true}
            closeIcon={closeIcon}
            onClose={() => this.setLearnMore(null)}
          >
            <LearnMore
              content={this.state.learnMore}
              playsInline={this.props.playsInline}
            />
          </Modal>
        )}

        <div className={playerPageClasses}>
          <div className="ssc__page__inner">
            <AudioPlayer
              audio={this.props.audio}
              loaded={this.props.audioLoaded}
              audioDuration={this.props.audioDuration}
              checkAudioRefusedToPlay={this.props.checkAudioRefusedToPlay}
            />

            <div className="ssc__player__learn-more-container ssc__clearfix">
              <a
                className="ssc__learn-more-title"
                href="http://www.nucalm.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h3 className="ssc__text-uppercase">
                  {this.content.nucalmText}
                </h3>
                <span>{cta}</span>
              </a>
              <ShareButton />
              <div className="ssc__learn-more__left-container">
                {this.content.leftGrid.map((gridItem, i) => (
                  <GridItem
                    key={i}
                    id={i + 1}
                    content={gridItem}
                    shapeClass={gridItem.shape}
                    setLearnMore={this.setLearnMore}
                  />
                ))}
              </div>
              <div className="ssc__learn-more__right-container">
                {rightGridOrdered.map((gridItem, i) => (
                  <GridItem
                    key={i}
                    id={i + 4}
                    content={gridItem}
                    shapeClass={gridItem.shape}
                    setLearnMore={this.setLearnMore}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerPage;



// WEBPACK FOOTER //
// ./src/components/PlayerPage/PlayerPage.js